import { useState } from "react";

import { Webchat, WebchatProvider, Fab, getClient } from "@botpress/webchat";
import { useTheme } from "@chakra-ui/react";
//Todo build out the bot here: https://botpress.com/docs/react-js
//Todo use the index.html script to customize better: 'https://cdn.botpress.cloud/webchat/v1/inject.js'
export const BotpressChat = () => {
  const chakraTheme = useTheme();

  const client = getClient({
    clientId: import.meta.env.VITE_BOTPRESS_CLIENT_ID
  });
  const [isWebchatOpen, setIsWebchatOpen] = useState(false);

  return (
    <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 1000 }}>
      <WebchatProvider client={client}>
        <Fab
          onClick={() => setIsWebchatOpen(!isWebchatOpen)}
          style={{
            background: chakraTheme.colors.brand.primary,
            color: "black"
          }}
        />
        <div
          style={{
            display: isWebchatOpen ? "block" : "none",
            position: "absolute",
            bottom: "80px",
            right: "0",
            width: "400px",
            height: "600px",
            backgroundColor: chakraTheme.colors.gray[800],
            borderRadius: "10px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
            overflow: "hidden",
            border: `1px solid ${chakraTheme.colors.gray[700]}`
          }}
        >
          <Webchat />
        </div>
      </WebchatProvider>
    </div>
  );
};
